export default __webpack_public_path__ + "static/media/btn_visa.11b99f22.png";